<div *ngIf="!isContactPage && contactData">
  <div class="help-support-main">
    <div class="container">
      <div class="row mx-0">
        <div class="col-md-8">
          <div class="help-left d-sm-flex justify-content-sm-between">
            <div class="help-col">
              <h4>Help & Support</h4>
              <p>Facing trouble using our product? You could reach out to us on:</p>
            </div>
            <div class="help-col">
              <div class="details">
                <a (click)="analyticsService.triggerSupportContactEvent(contactData?.helpSupport?.phoneNumber,'Help & Support')"
                  href="tel:{{contactData?.helpSupport?.phoneNumber}}">
                  <div class="img-box">
                    <img loading="lazy" width="24" height="24" [src]="environment?.blobUrl+'/assets/images/contact-us/phone.svg'" alt="Phone | Luminous">
                  </div>
                  <div class="content">
                    <p>
                      {{contactData?.helpSupport?.phoneNumber}}
                    </p>
                    <span>{{contactData?.helpSupport?.phoneHours}}</span>
                  </div>
                </a>
              </div>
              <div class="details">
                <a role="button"
                  (click)="analyticsService.triggerSupportContactEvent(contactData?.helpSupport?.whatsappNumber,'Help & Support')"
                  href="https://api.whatsapp.com/send?phone={{contactData?.helpSupport?.whatsappNumber}}"
                  target="_blank">
                  <div class="img-box">
                    <img loading="lazy" width="24" height="24" [src]="environment?.blobUrl+'/assets/images/contact-us/chat.svg'" alt="Chat | Luminous">
                  </div>
                  <div class="content">
                    <p>
                      +91-{{contactData?.helpSupport?.whatsappNumber}}
                    </p>
                  </div>
                </a>
              </div>
              <div class="details">
                <a (click)="analyticsService.triggerSupportContactEvent(contactData?.helpSupport?.email,'Help & Support')"
                  href="mailto:{{contactData?.helpSupport?.email}}">
                  <div class="img-box">
                    <img loading="lazy" width="24" height="24" [src]="environment?.blobUrl+'/assets/images/contact-us/email.svg'" alt="Email | Luminous">
                  </div>
                  <div class="content">
                    <p>
                      {{contactData?.helpSupport?.email}}
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="help-right d-md-flex align-items-md-center">
            <ul>
              <li>
                <a class="d-flex arrow" [routerLink]="['/enquiry']">
                  <img loading="lazy" [src]="environment?.blobUrl + '/assets/images/customer-support/register.svg'" alt="Business Enquiry | Luminous">
                  <p>Business Enquiry</p>
                </a>
              </li>
              <li>
                <a class="d-flex arrow" [routerLink]="['/book-complaint']">
                  <img loading="lazy" [src]="environment?.blobUrl + '/assets/images/customer-support/complaint-icon.svg'" alt="Complaint | Luminous">
                  <p>Book a complaint</p>
                </a>
              </li>
              <li>
                <a class="d-flex arrow" [routerLink]="['/warranty-registration']">
                  <img loading="lazy" [src]="environment?.blobUrl + '/assets/images/customer-support/register.svg'" alt="Register | Luminous">
                  <p>Register your product</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isContactPage && contactData">
  <div class="supporthelp-wrap">
    <div class="container">
      <div class="supporthelp">
        <div class="row">
          <div class="col-md-4">
            <div class="content">
              <h3>Help & Support</h3>
              <p>Reach out to us and our support team will assist you</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="help-col">
              <div class="head">
                <img loading="lazy" [src]="environment?.blobUrl+'/assets/images/contact-us/email.svg'" alt="Email | Luminous">
                <p>Email Us</p>
              </div>
              <div class="details" *ngFor="let email of contactData.contactUs.emailContacts">
                <a href="mailto:{{email.email}}">
                  <span>{{email.purpose}}</span>
                  <p>{{email.email}}</p>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="help-col">
              <div class="help-right d-md-flex flex-md-column justify-content-md-between">
                <div>
                  <div class="head">
                    <img loading="lazy" [src]="environment?.blobUrl+'/assets/images/contact-us/chat.svg'" alt="Chat | Luminous">
                    <p>Chat with us</p>
                  </div>
                  <div class="details" *ngFor="let chat of contactData.contactUs.chatContacts">
                    <a target="_blank" (click)="analyticsService.trackContactUs()"
                      href="https://api.whatsapp.com/send?phone={{chat.number}}">
                      <span>{{chat.purpose}}</span>
                      <p>+91-{{chat.number}}</p>
                    </a>
                  </div>
                </div>
                <div>
                  <div class="head">
                    <img loading="lazy" [src]="environment?.blobUrl+'/assets/images/contact-us/phone.svg'" alt="Phone | Luminous">
                    <p>Call us</p>
                  </div>
                  <div class="details" *ngFor="let phone of contactData.contactUs.phoneContacts">
                    <a (click)="analyticsService.trackContactUs()" href="tel:{{phone.number}}">
                      <span>{{phone.purpose}}</span>
                      <p>{{phone.number}}</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>